<template>
  <TourFilterPopupWrapper
    :title="title"
    :static-title="headerTitle"
    :is-modal-only="isFullscreen"
    :is-active="isActive"
    class="filter-dates"
    filter-key="duration"
    :is-disabled-reset-button="isDisabledResetButton"
    :is-scroll="isScroll"
  >
    <TourFilterDurationContent :max-duration="maxDurationEnd" />
  </TourFilterPopupWrapper>
</template>

<script setup lang="ts">
  import { TourFilterPopupWrapper } from '@/entities/filter/popup-wrapper';
  import TourFilterDurationContent from './TourFilterDurationContent.vue';
  import { useTourFiltersStore } from '@/entities/filter/store/tour';
  import { useTourFilterDurationTitle } from '../../composables/tour/useTourFilterDurationTitle.ts';
  import { DAY_HOURS } from '../../const/config.ts';
  import { locales } from '../../i18n';

  interface Props {
    duration: Record<string, number>;
    isFullscreen: boolean;
    isScroll: boolean;
  }

  const props = defineProps<Props>();

  const filterStore = useTourFiltersStore();

  // Вычитываем максимальное количество дней в турах
  const maxDurationEnd = computed(() => {
    return Number(Object.keys(props.duration).at(-1)) / DAY_HOURS;
  });

  const { title, headerTitle, isActive } = useTourFilterDurationTitle(locales.ru);

  const isDisabledResetButton = computed(() => {
    return !filterStore.state.duration[0] && !filterStore.state.duration[1];
  });
</script>

<style lang="scss" scoped>
  :deep(.filter-popup) {
    width: 368px;
    max-width: 100vw;

    .popup__header {
      padding-bottom: 11px;
    }

    .popup__content {
      padding-top: 5px;
    }
  }
</style>
